<template>
  <div
    class="text-center laptop:mt-8 laptop:mb-6 my-6 mobile:my-3 grid laptop:grid-cols-3 desktop:grid-cols-3 largeDesktop:grid-cols-3 mobile:grid-cols-1 items-center mobile:gap-3 laptop:gap-5">
    <div />
    <!-- flex flex-col gap-[5px] -->
    <div class="text-center flex flex-col gap-[5px]">
      <h2 class="mb-0 font-bold font-roboto mobile:text-xl laptop:text-2xl largeDesktop:text-[30px] text-[#333]">
        {{ getHeading() }}
      </h2>
      <p v-if="getText()"
        class="mb-0 font-normal font-roboto mobile:text-base desktop:text-[16px] largeDesktop:text-[19px] text-[#666666]">
        {{ getText() }}
      </p>
    </div>
    <div v-if="isShowProtectionPlanNumber" class="laptop:text-right mobile:text-center">
      <p class="mb-0 font-normal font-roboto mobile:text-base desktop:text-lg text-[#666666]">
        Protection Plan Questions
        Call
      </p>
      <a href="tel:+18668433371"
        class="mb-0 font-bold font-roboto mobile:text-lg laptop:text-xl largeDesktop:text-2xl no-underline text-[#A084E8]">
        (866)-843-3371
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    heading: {
      type: String,
      default: 'Welcome',
    },
    text: {
      type: String,
      default: 'Let’s make today productive and achieve some great results',
    },
  },

  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')) ?? null
    };
  },

  computed: {
    isShowProtectionPlanNumber() {
      if (this.$route.name == 'salesHistory') {
        return false
      } else if (
        this.$route.name == 'hvac-plan' ||
        this.$route.name == 'partner' ||
        this.$route.name == 'protections-plans' ||
        this.$route.name == 'plan' ||
        this.$route.name == 'bundleList' ||
        this.$route.name == 'plumbing-plan' ||
        this.$route.name == 'electric-plan'
      ) {
        return true
      } else {
        // global search now covers every module, not just protection plans: no plan helpline there
        return false
      }
    },
  },

  methods: {

    // Work Order listings show the page title instead of the welcome text (Figma "Work Orders - …")
    workOrderSubtitle() {
      const subtitles = {
        appointment: 'Appointments',
        serviceRepair: 'Service & Repair History',
        replacementQuote: 'Replacement Quote History',
        universalQuotes: 'Universal Quotes',
      };
      if (['AppointmentDetail', 'appointment-members'].includes(this.$route.name)) {
        return 'Appointment: ' + this.$route.params.id;
      }
      if (String(this.$route.name || '').startsWith('rq-create-')) {
        return 'Create Replacement Quote';
      }
      if (['rq-detail', 'rq-data-sheet', 'rq-summary', 'rq-summary-edit'].includes(this.$route.name)) {
        return 'Replacement Quote: ' + this.$route.params.id;
      }
      if (['QuoteDetail', 'QuoteEdit', 'quote-members'].includes(this.$route.name)) {
        return 'Universal Quotes: ' + this.$route.params.id;
      }
      if (['job-detail', 'job-members', 'select-unit', 'last-evaluation', 'equipment', 'initial-check', 'summary', 'edit-summary', 'final-evaluation', 'summary-detail', 'job-invoice', 'view-evaluation'].includes(this.$route.name)) {
        return 'Service & Repair: ' + this.$route.params.id;
      }
      return subtitles[this.$route.name] || '';
    },

    getText() {
      if (this.$route.name == 'messages') {
        return 'Your chats with consumers'
      } else if (this.$route.name == 'checkoutDetail') {
        return 'Invoice ' + this.$route.params.id
      } else if (this.workOrderSubtitle()) {
        return this.workOrderSubtitle()
      } else if (this.$route.name == 'salesHistory') {
        return 'Protection Plans - Sales History'
      } else if (this.$route.name == 'commisionAmount') {
        return 'Protection Plans - Commissions'
      } else if (
        this.$route.name == 'hvac-plan' ||
        this.$route.name == 'partner' ||
        this.$route.name == 'protections-plans' ||
        this.$route.name == 'plan' ||
        this.$route.name == 'bundleList' ||
        this.$route.name == 'plumbing-plan' ||
        this.$route.name == 'electric-plan'
      ) {
        return 'Optional NRG Protects Inc Protection Plans'
      } else if (
        this.$route.name == 'globalSearch'
      ) {
        return 'Results matching your search criteria are listed below.'
      } else if (this.$route.name == 'dashboard') {
        // Dashboard: only "Welcome <name>!" (no tagline)
        return ''
      } else {
        return 'Let’s make today productive and achieve some great results'
      }
    },

    getHeading() {
      // Figma P1–P14: "Payment Method"
      if (this.$route.name == 'messages') {
        return 'Messages'
      } else if (this.$route.name == 'checkoutDetail') {
        return 'Payment Method'
      } else if (this.workOrderSubtitle()) {
        return 'Work Orders'
      } else if (this.$route.name == 'salesHistory' || this.$route.name == 'commisionAmount') {
        return 'Protection Plans'
      } else if (
        this.$route.name == 'hvac-plan' ||
        this.$route.name == 'partner' ||
        this.$route.name == 'protections-plans' ||
        this.$route.name == 'plan' ||
        this.$route.name == 'bundleList' ||
        this.$route.name == 'plumbing-plan' ||
        this.$route.name == 'electric-plan'
      ) {
        return 'Protection Plans'
      } else if (
        this.$route.name == 'globalSearch'
      ) {
        return 'Search Results '
      } else if (
        this.$route.name == 'partnerCheckout'
      ) {
        return 'Checkout '
      } else {
        return 'Welcome ' + (this.user ? this.user.user.full_name : '') + '!'
      }
    }

  },
}
</script>